
 @switch (sidebarState) {
   @case (0) {
    <div class="sidebar-ev sidebar-desktop-large">
        <div class="profile-info">
            @if(currentUser()){
                <img [src]="
                currentUser() && currentUser()?.pictureUrl ?
                currentUser()?.pictureUrl : 'assets/images/no-image.svg'" alt="User" class="user-avatar" />
            } @else {
                <p-skeleton class="sidebar-skeleton" shape="circle" size="2.4rem" styleClass="mb-1"/>
            }

            <div class="flex flex-column" style="font-size: 14px;">
                @if(currentUser()){
                    <span>Welcome,</span>
                    <strong class="mt-1">{{ currentUser()?.firstName }}!</strong>
                } @else {
                    <p-skeleton width="5rem" styleClass="mb-2 mx-2" />
                    <p-skeleton width="8rem" styleClass="mx-2" />
                }
            </div>
        </div>


        @if(currentUser()){
            <div class="search-bar">
                <p-iconField iconPosition="left">
                    <p-inputIcon styleClass="pi pi-search"/>
                    <input type="text" pInputText placeholder="Search" style="width: 100%;" [(ngModel)]="filterMenu"/>
                </p-iconField>
            </div>
            <p-panelMenu class="panel-side-menu" [model]="menuItemsTemp()" [multiple]="true">
                <ng-template pTemplate="item" let-item>
                    <ng-container *ngIf="item.route; else urlRef">
                        <a [routerLink]="item.route"
                        [ngClass]="{
                            'ml-2': item.child,
                            'active': item.active
                        }"
                        class="flex align-items-center
                            cursor-pointer text-color px-1 py-2 no-underline text-sm">
                            <span [class]="item.icon" style="width: 12px;"></span>
                            <span class="ml-2 text-color">{{ item.label }}</span>
                        </a>
                    </ng-container>
                    <ng-template #urlRef>
                        <a *ngIf="item.url; else noLink" [href]="item.url"
                        [ngClass]="{
                            'ml-2': item.child,
                            'active': item.active
                        }"
                        class="flex align-items-center
                            cursor-pointer text-color px-1 py-2 no-underline text-sm">
                            <span [class]="item.icon" style="width: 12px;"></span>
                            <span class="ml-2">{{ item.label }}</span>
                        </a>
                        <ng-template #noLink>
                            <span [ngClass]="item.child ? 'ml-2':null" class="flex align-items-center cursor-pointer px-1 py-2 no-underline text-sm">
                                <span [class]="item.icon" style="width: 12px;"></span>
                                <span class="ml-2">{{ item.label }}</span>
                                <i *ngIf="item.items && item.expanded" class="fa fa-angle-down ml-auto"></i>
                                <i *ngIf="item.items && !item.expanded" class="fa fa-angle-left ml-auto"></i>
                            </span>
                        </ng-template>
                    </ng-template>

                </ng-template>
            </p-panelMenu>

        } @else {
            <div class="my-1">
                <p-skeleton height="2.5rem"/>
            </div>

            @for (item of menuSkeletons; track item) {
                <div class="my-3 w-full flex align-items-center">
                    <div class="mr-1">
                        <p-skeleton height="1.7rem" width="1.7rem" shape="circle"/>
                    </div>
                    <div class="w-full">
                        <p-skeleton height="1.7rem" />
                    </div>
                </div>
            }
        }


    </div>
   }
   @case (1){
    <div class="sidebar-ev  sidebar-desktop-small">
        @if(currentUser()){
            <div class="profile-info">
                <img  [src]="
                currentUser() && currentUser()?.pictureUrl ?
                currentUser()?.pictureUrl : 'assets/images/no-image.svg'" alt="User" class="user-avatar"
                      [pTooltip]="(currentUser()?.firstName + ' ' + currentUser()?.lastName).trim()"
                      tooltipPosition="right"
                      />
            </div>
            <p-panelMenu class="panel-side-menu" [model]="menuItemsTemp()" [multiple]="true">
                <ng-template pTemplate="item" let-item>
                    <ng-container *ngIf="item.route; else urlRef">
                        <a [routerLink]="item.route" class="flex align-items-center justify-content-between
                            cursor-pointer text-color px-1 py-2 no-underline text-sm"
                            [pTooltip]="tooltipContent" tooltipPosition="right" tooltipStyleClass="menu-item-tooltip">
                            <span [class]="item.icon" style="width: 12px;"></span>
                            <!-- <span class="ml-2 text-color">{{ item.label }}</span> -->
                        </a>

                    </ng-container>
                    <ng-template #urlRef>
                        <a *ngIf="item.url; else noLink" [href]="item.url"
                            class="flex align-items-center justify-content-between
                            cursor-pointer text-color px-1 py-2 no-underline text-sm"
                            [pTooltip]="tooltipContent" tooltipPosition="right" tooltipStyleClass="menu-item-tooltip">
                            <span [class]="item.icon" style="width: 12px;"></span>
                            <!-- <span class="ml-2">{{ item.label }}</span> -->
                        </a>
                        <ng-template #noLink>
                            <span  class="flex align-items-center justify-content-between cursor-pointer px-1 py-2 no-underline text-sm"
                            [pTooltip]="tooltipContent" tooltipPosition="right" tooltipStyleClass="menu-item-tooltip">
                                <span [class]="item.icon" style="width: 12px;"></span>
                                <!-- <span class="ml-2">{{ item.label }}</span> -->
                                <i *ngIf="item.items && item.expanded" class="ml-2 fa fa-angle-down"></i>
                                <i *ngIf="item.items && !item.expanded" class="ml-2 fa fa-angle-up"></i>
                            </span>
                        </ng-template>

                    </ng-template>
                    <ng-template #tooltipContent>
                        <div class="flex align-items-center justify-content-between">
                            <span [class]="item.icon" style="width: 12px;"></span>
                            <span class="ml-3">{{ item.label }}</span>
                        </div>
                    </ng-template>
                </ng-template>
            </p-panelMenu>
        } @else {
            <div class="profile-info ml-1">
                <p-skeleton class="sidebar-skeleton" shape="circle" size="2.4rem" styleClass="mb-1"/>
            </div>
            <div class="mt-1">
                @for (item of menuSkeletons; track item) {
                    <div class="my-3 w-full flex justify-content-center">
                        <p-skeleton height="1.8rem" shape="circle" width="1.8rem"/>
                    </div>
                }
            </div>
        }

    </div>
   }
   @case (2){
    <p-sidebar #sidebarRef [(visible)]="isMobileSidebarVisible">
        <ng-template pTemplate="headless">
            <div class="flex flex-column h-full">
                <div class="sidebar-mobile">
                    <div class="flex justify-content-between mb-3">
                        <div class="mobile-profile-info">
                            @if(currentUser()){
                                <img [src]="
                                currentUser() && currentUser()?.pictureUrl ?
                                currentUser()?.pictureUrl : 'assets/images/no-image.svg'" alt="User" class="user-avatar" />
                            } @else {
                                <p-skeleton class="sidebar-skeleton" shape="circle" size="2.4rem" styleClass="mb-1"/>
                            }

                            <div class="flex flex-column" style="font-size: 14px;">
                                @if(currentUser()){
                                    <span>Welcome,</span>
                                    <strong class="mt-1">{{ currentUser()?.firstName }}!</strong>
                                } @else {
                                    <p-skeleton width="5rem" styleClass="mb-2 mx-2" />
                                    <p-skeleton width="8rem" styleClass="mx-2" />
                                }
                            </div>
                        </div>

                        <div>
                            <span class="fa fa-times cursor-pointer text-xl text-gray-400"
                                  (click)="onCloseMobileSidebar(sidebarRef,$event)"  >

                            </span>
                        </div>
                    </div>

                    @if(currentUser()){
                        <div class="search-bar">
                            <p-iconField iconPosition="left">
                                <p-inputIcon styleClass="pi pi-search" />
                                <input type="text" pInputText placeholder="Search" style="width: 100%;" [(ngModel)]="filterMenu"/>
                            </p-iconField>
                        </div>

                        <p-panelMenu class="sidebar-ev panel-side-menu" [model]="menuItemsTemp()" [multiple]="true">
                            <ng-template pTemplate="item" let-item>
                                <ng-container *ngIf="item.route; else urlRef">
                                    <a [routerLink]="item.route" [ngClass]="item.child ? 'ml-2':null" class="flex align-items-center
                                        cursor-pointer text-color px-1 py-2 no-underline text-sm">
                                        <span [class]="item.icon" style="width: 12px;"></span>
                                        <span class="ml-2 text-color">{{ item.label }}</span>
                                    </a>
                                </ng-container>
                                <ng-template #urlRef>
                                    <a *ngIf="item.url; else noLink" [href]="item.url"
                                    [ngClass]="item.child ? 'ml-2':null"
                                    class="flex align-items-center
                                        cursor-pointer text-color px-1 py-2 no-underline text-sm">
                                        <span [class]="item.icon" style="width: 12px;"></span>
                                        <span class="ml-2">{{ item.label }}</span>
                                    </a>
                                    <ng-template #noLink>
                                        <span [ngClass]="item.child ? 'ml-2':null" class="flex align-items-center cursor-pointer px-1 py-2 no-underline text-sm">
                                            <span [class]="item.icon" style="width: 12px;"></span>
                                            <span class="ml-2">{{ item.label }}</span>
                                            <i *ngIf="item.items && item.expanded" class="fa fa-angle-down ml-auto"></i>
                                            <i *ngIf="item.items && !item.expanded" class="fa fa-angle-left ml-auto"></i>
                                        </span>
                                    </ng-template>
                                </ng-template>

                            </ng-template>
                        </p-panelMenu>
                    } @else {
                        <div class="my-1">
                            <p-skeleton height="2.5rem"/>
                        </div>
                        @for (item of menuSkeletons; track item) {
                            <div class="my-3 w-full flex align-items-center">
                                <div class="mr-1">
                                    <p-skeleton height="1.7rem" width="1.7rem" shape="circle"/>
                                </div>
                                <div class="w-full">
                                    <p-skeleton height="1.7rem" />
                                </div>
                            </div>
                        }
                    }

                </div>
            </div>
        </ng-template>
    </p-sidebar>
   }
 }
